<template>
    <div>
      <div class="container-fluid">
        <div data-widget-group="group1">
          <ol class="breadcrumb">
            <li class="active">
              <router-link to="/admin">Dashboard</router-link>
            </li>
            <li class="active"><a href="#">Update Type</a></li>
          </ol>
          <div class="panel-body locationform">
            <div v-if="message" class="alert-danger alert visibility" role="alert">
              {{ message }}
            </div>
            <div v-if="SuccessMessage" class="alert-info alert visibility" role="alert">
              {{ SuccessMessage }}
            </div>
            <form @submit.prevent="submitForm">
              <div class="row">
                    <legend>Edit User Type:</legend>
                    <div class="col-xs-4">
                      Name:
                    </div>
                    <div class="col-xs-2">
                      Phone:
                    </div>
                    <div class="col-xs-3">
                      Email:
                    </div>
                    <div class="col-xs-3">
                      Type:
                    </div>
                    <div class="col-xs-4">
                      {{userData.first_name}}
                      {{userData.last_name}}
                    </div>
                    <div class="col-xs-2">
                      {{userData.phone}}
                    </div>
                    <div class="col-xs-3">
                      {{userData.email}}
                    </div>
                    <div class="col-xs-3">
                      {{userData.PartnerType}}
                    </div>
                    <div class="col-xs-6">
                      <div class="form-group mb-md">
                        <v-select
                          v-model="OrganizationType"
                          :reduce="(seg) => seg.value"
                          :label="'text'"
                          :options="optionsOrganizationType"
                          :clearable="false"
                          :searchable="false"
                          @input="changedOrganizationType"
                        ></v-select>
                      </div>
                    </div>
                    <div class="col-xs-6">
                      <div class="form-group mb-md">
                        <v-select
                          v-model="partnerType"
                          :reduce="(seg) => seg.value"
                          :label="'text'"
                          :options="optionsPartnerRolesTypes"
                          :clearable="false"
                          :searchable="false"
                          @input="registerComponentEnable"
                          :disabled="partnerTypeIsEnable"
                        ></v-select>
                      </div>
                    </div>
                    
              </div>
              <div class="row">
                <div class="col-sm-3 col-sm-offset-9">
                          <div class="form-group">
                            <button
                              class="btn-raised btn-primary btn fixcolorAs"
                              :disabled="loading"
                            >
                              <span
                                v-show="loading"
                                class="spinner-border spinner-border-sm"
                              ></span>
                              <span>Submit</span>
                            </button>
                          </div>
                    </div>
              </div>           
            </form>
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
  import vSelect from 'vue-select';
  import 'vue-select/dist/vue-select.css';
  import UserService from '../services/user.service';
  import Vue from 'vue';
  
  function initialState() {
    return {
            phone:'',
            email:'',
            first_name:'',
            last_name:'',
            PartnerType:'',
        }
  }
  export default {
    name: 'addEmployee',
    data() {
      return {
        loading:false,
        isReadOnly:true,
        message: '',
        SuccessMessage:'',
        userData: initialState(),
        readonly_component: true,
        partnerTypeIsEnable: true,
  
        ErrorMessage:'',
        OrganizationType: null,
        optionsOrganizationType: [
          { value: null, text: 'Please Select Organisation Type' },
          { value: 'Channel Partner', text: 'Channel Partner' },
          { value: 'Service Partner', text: 'Service Partner' },
        ],
        partnerType: '',
        optionsPartnerRolesTypes: [],
        optionChannelPartner: [
          { value: '1', text: 'Select Channel Partner' },
          { value: 'Distributors', text: 'Distributors' },
          { value: 'Retailer', text: 'Retailer' },
        ],
        optionServicePartner: [
          { value: '1', text: 'Select Service Partner' },
          { value: 'Reborer', text: 'Reborer' },
          { value: 'Grinder', text: 'Grinder' },
          { value: 'ReborerPlusGrinder', text: 'Grinder Reborer' },
          { value: 'Mechanics', text: 'Mechanics' },
        ],
      };
    },
    computed: {
    },
    beforeCreate() {
      this.$store.commit('SET_LAYOUT', 'app-layout');
    },
    components: { vSelect },
    methods: {
      changedOrganizationType(value) {
        if (value == 'Channel Partner') {
          this.partnerTypeIsEnable = false;
          this.optionsPartnerRolesTypes = [];
          this.optionsPartnerRolesTypes = this.optionChannelPartner;
          this.partnerType = '1';
          this.readonly_component = true;
        } else if (value == 'Service Partner') {
          this.partnerTypeIsEnable = false;
          this.optionsPartnerRolesTypes = [];
          this.optionsPartnerRolesTypes = this.optionServicePartner;
          this.partnerType = '1';
          this.readonly_component = true;
        } else {
          this.partnerTypeIsEnable = true;
          this.optionsPartnerRolesTypes = [];
          this.partnerType = null;
        }
      },
      registerComponentEnable(val) {
        if (val != '1') {
          this.readonly_component = false;
          this.loading = false;
          this.userData.PartnerType = val;
        } else {
          this.readonly_component = true;
          this.loading = true;
        }
      },
      submitForm() {
        this.$validator.validateAll().then((res) => {
          if (res) {
            let loader = this.$loading.show();
            UserService.postMetod(
              'kspgAPI/Partners/update',
              this.userData
            ).then(
              (response) => {
                this.SuccessMessage = response.data.message;
                setTimeout(() => (this.SuccessMessage = false), 5000);
                this.loading = false;
                // on success reset values
                if (response.data.status) {
                  this.resetWindow();
                  /*Clear Validation */
                   this.$nextTick(() => {
                      this.errors.clear();
                      this.$nextTick(() => {
                          this.$validator.reset();
                      });
                  });
                }
              },
              (error) => {
                this.loading = false;
  
                this.message =
                  (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                  error.message ||
                  error.toString();
              }
            );
            setTimeout(() => {loader.hide()}, 1000)
          } else {
            this.message = 'Please correct all error!';
          }
        });
      },
      resetWindow: function () {
        Object.assign(this.$data.userData, initialState());
      },
      getPrefilledData() {
        let loader = this.$loading.show();
        /*get  Employee Data */
        let param = {};
        param.email = this.$route.params.email;
        UserService.getMetod('kspgAPI/Partners/detail', param).then(
          (response) => {
            // alert(response.data.models);
            // vm.results = response.data.models
            const { register } = response.data;
            this.userData = register;
          },
          (error) => {
            this.loading = false;
  
            this.ErrorMessage =
              (error.response &&
                error.response.data &&
                error.response.data.message) ||
              error.message ||
              error.toString();
              setTimeout(() => (this.ErrorMessage = false), 5000);
          }
        );
        // this.skyloEnd();
        setTimeout(() => {loader.hide()}, 2000)
      },
    }, 
    created() {
      this.getPrefilledData();
    },
  };
  </script>
  <style>
  .visibility {
    visibility:visible !important;
  }
  
  </style>